export default __webpack_public_path__ + "static/media/checkIn3.47da6528.svg";